module.exports = __webpack_public_path__ + "img/part-2-title.fb7ac7f9.png";